<script>
import PlayerControlPanel from 'v/PlayerControlPanel.vue';

export default PlayerControlPanel.extend({
  created: function () {
    const rcp = this.$options.rcp;
    const MSG = rcp.constructor.MSG;

    // wire RCP panel with RCP player
    rcp.on(MSG.PROGRESS, (time) => {
      const offset = this.ceil1e3(this.time.offset);
      this.time.current = ((time * 1e3) | 0) / 1e3 - offset;

      // why...
      // this is a HACK
      // the overlay asset total time is to accurate
      // this means that the total time could be less then the current time
      // with a gap that less then 1e-3.
      // the hack is to multiply the total time 1e3 ceil Math it and dev it by 1e3
      const totalTime = this.ceil1e3(this.time.total);

      if (totalTime < this.time.current) {
        rcp.pause();
        rcp.seek(offset + this.time.total);
      } else if (this.time.current < 0) {
        rcp.seek(offset);
      }
    });
    rcp.on(MSG.PLAY, () => {
      this.playing = true;
    });
    rcp.on(MSG.PAUSE, () => {
      this.playing = false;
    });
    rcp.on(MSG.VOLUMECHANGE, (volume) => {
      if (this.volume.current !== volume) {
        this.volume.current = volume;
      }
    });

    this.$on('togglePlay', (loop) => {
      const offset = this.ceil1e3(this.time.offset);
      if (
        (((offset + this.time.total) * 1e3) | 0) / 1e3 <=
        rcp.getCurrentTime()
      ) {
        rcp.togglePlay({ startTime: offset, loop });
      } else {
        rcp.togglePlay({ loop });
      }
    });

    this.$on('seek', ({ time, e }) => {
      const offset = this.ceil1e3(this.time.offset);
      time = ((time * 1e3) | 0) / 1e3 + offset;
      if (time !== rcp.getCurrentTime()) {
        if (rcp.isPlaying()) {
          rcp.seekImmediate(time);
        } else {
          rcp.seek(time);
        }
      }
    });

    this.$on('volume', (volume) => {
      volume = ((volume * 1e3) | 0) / 1e3;
      if (volume !== rcp.getVolume()) {
        rcp.setVolume(volume);
      }
    });

    this.$on('replay', () => {
      const offset = this.ceil1e3(this.time.offset);
      rcp.pause();
      rcp.play({ startTime: offset });
    });
  },
  methods: {
    ceil1e3(number = 0) {
      return Math.ceil(number * 1e3) / 1e3;
    },
  },
  data: function () {
    const rcp = this.$options.rcp;
    const volume = rcp.getVolume();

    return {
      volume: {
        current: volume,
        beforeMute: volume,
      },
      playing: rcp.isPlaying(),
    };
  },
});
</script>
